export default __webpack_public_path__ + "static/media/processing-animate.dffcb6cb.svg";